<template>
    <div id="ticket" class="page">                                            

        



        <div class="recibo">
            <div class="header">
                <div class="header-row">
                    <div class="header-cell" style="width:120px;">
                        <img src="logo.png" class="logo">
                    </div>
                    <div class="header-cell titulo">
                        <h2>ESCUELA NORMAL URBANA</h2>
                        <p>PERIFERICO S/N COL. LAS FLORES</p>
                    </div>
                    <div class="header-cell info-derecha">
                        Fecha: 19/08/2025<br>
                        Recibo No. <span class="recibo-num">8820</span><br><br>
                        Grupo "{{ alumno.grupo }}" - {{ alumno.semestre }}° Semestre<br>
                        {{ alumno.oferta }}
                    </div>
                </div>
            </div>
            <div class="seccion">
                <span class="negrita">Nombre del Alumno:</span>
                {{ alumno.nombre }} {{ alumno.apellido_paterno }} {{ alumno.apellido_materno }}
            </div>
            <div class="linea"></div>
            <!-- TABLA CONCEPTOS -->
            <table>
                <thead>
                    <tr>
                        <th>Plan</th>
                        <th>Cant.</th>
                        <th>Concepto de Pago</th>
                        <th class="text-right">Cantidad</th>
                        <th class="text-right">Recargos</th>
                        <th class="text-right">Beca</th>
                        <th class="text-right">Desc.</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>REINS</td>
                        <td>1</td>
                        <td>REINSCRIPCION Ago/2025 PAGO</td>
                        <td class="text-right">2,804.92</td>
                        <td class="text-right">0.00</td>
                        <td class="text-right">0.00</td>
                        <td class="text-right">0.00</td>
                    </tr>
                </tbody>
            </table>
            <div class="linea"></div>
            <div>
                <span class="negrita">FORMA DE PAGO:</span> {{ formatearPago(alumno.forma_pago) }}
            </div>
            <div class="totales">
                <table>
                    <tr>
                        <td>SUBTOTAL</td>
                        <td class="text-right">2,804.92</td>
                    </tr>
                    <tr>
                        <td>CARGOS +</td>
                        <td class="text-right">0.00</td>
                    </tr>
                    <tr>
                        <td>DESCUENTOS -</td>
                        <td class="text-right">0.00</td>
                    </tr>
                    <tr>
                        <td>BECA -</td>
                        <td class="text-right">0.00</td>
                    </tr>
                    <tr class="total-final">
                        <td>TOTAL</td>
                        <td class="text-right">2,804.92</td>
                    </tr>
                </table>
            </div>
            <div class="footer">
                <p><span class="negrita">CANTIDAD CON LETRA:</span><br>
                DOS MIL OCHOCIENTOS CUATRO PESOS 92/100 M.N.</p>

                <p><span class="negrita">LE ATENDIÓ:</span> JOSEFA CONCEPCIÓN TEJERO MUÑOZ</p>
            </div>
        </div>













    </div>
</template>
<script>
/* eslint-disable */
import { watch } from 'vue';
import { useRoute } from 'vue-router';

import { mapState } from 'vuex'
import { mapMutations } from 'vuex'
import * as calculos  from '@/librerias/lobato-calculos.js'
//import PouchDB  from '@/librerias/pouchdb/pouchdb.min.js'

//import html2canvas   from '@/librerias/html2canvas.min.js'
//import html2canvas from 'html2canvas'

export default {
    name: 'com_general',
    props: {
        msg: String
    },
    data() {
        return {
            datos:{
                id:this.$route.params.id,
                          
            }
        }
    },
    mounted(){
        this.inicial();
    },
    methods:{
        ...mapMutations(['funciones','alerta']),  
         inicial()
        {
            const routerView = this.$el;
            document.body.innerHTML = '';
            document.body.appendChild(routerView);                  
            this.obtener_datos();                                  
        },
        obtener_datos()
        {
            console.log('id ');
            console.log(this.datos.id);            

            fetch(`${this.general.otros.dominio_server}/inscripciones/${this.datos.id}/formato1/datos`,{
                method:'GET',
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{
                console.log('datos : ');
                console.log(respuesta);
                /* if(respuesta.datos.venta.length>0)
                {
                    let r=respuesta.datos.venta[0]; */
                    /* for (const p in this.datos.ticket) {                    
                        if(p=='productos')
                        {
                            this.datos.ticket[p]=p in r ? r[p] : [];                            
                        }
                        else if(p=='prestamos')
                        {
                            
                        }
                        else
                        {
                            this.datos.ticket[p]=p in r ? r[p] : this.datos.ticket[p];
                        }
                    } */
                    /* setTimeout(() => {
                        //console.log("Retrasado por 3 segundo.");
                        //this.generar_imagen();
                        window.print();
                    }, "2000");

                } */
            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los datos`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;                
            });
            
            
        },
        formato_moneda(m)
        {
            m=calculos.revisar_numero(m);
            return (m).toLocaleString("es-MX",{
                style: 'currency',
                currency: 'MXN'
            });
        },

        formatearPago(valor) {
            const pagos = {
                transferencia_deposito: "Transferencia / Depósito",
                efectivo: "Efectivo"
            }
            return pagos[valor] || valor
        }
    },


    



    computed: {
        ...mapState(['general']),
        alumno() {
            return this.datos?.inscripcion?.[0] || {}
        }
    },
}
</script>

<style lang="scss" scoped>

    #titulo-tabla-materiales{
        text-align:center;
        font-size:1rem;
        margin:0px;
    }
    #titulo-tabla-prestamos{
        text-align:center;
        font-size:0.7em;
        margin:0px;
    }
    #total-ticket{
        text-align:center;
        font-size:1rem !important;
        font-weight:800 !important;
        margin:0px;
    }

    #total-final-ticket{
        text-align:center;
        font-size:1rem !important;
        font-weight:800 !important;
        margin:0px;
    }


    #ticket{
        label{
            font-size:1rem;
            text-align:left;
            width:100%;
        }
        
    }
    
    

/*GENERAL*/

* {
	box-sizing: border-box;
	-moz-box-sizing: border-box;
}


.page{
	//width:	21.59cm !important;
    width:5.5cm !important;
	//height:	27.94cm;
	/*min-height:	29.7cm;*/
	//padding: 1.1cm !important;
    padding:0em;
	margin: 1cm auto !important;
	border: 1px #D3D3D3 solid !important;
	border-radius: 5px !important;
	box-shadow: 0 0 5px rgba(0, 0, 0, 0.1) !important;
    background:white;
}
.title-pre-catalogo {
	font-size: 15px;
	font-weight: bold;
	color:black;
	margin-top: 20px;
	margin-bottom: 0px;
}
.catego-expo{
	margin-top: 20px; 
	border-top: solid black 2px; 
	border-bottom: dashed black 1px; 
	padding: 10px 0;
}
.tabla-categoria-exposicion{
	margin-top: 20px; 
}
table.table.table-rounded.table-os{
	margin-bottom:0;
}

    .table th, .table td{
        font-weight:700 !important;
        font-size:0.6rem !important;

    }

    table tr th, table tr td{
        padding: 0px !important;

    }


@page { 
	size: letter;
	margin: 0;
} 
@media print { 

    label{
        font-weight:800 !important;
    }

    body{
        font-size:1rem !important;
        font-weight:800 !important;
        padding:0px !important;
        margin:0px !important;
    }

    .table th, .table td{
        font-weight:bold !important;
        font-size:0.95rem !important;
    }

    table tr th, table tr td{
        padding: 0px !important;
        border-bottom:2px solid black;
    }



	#ticket { 
		margin: 0;         
		padding: 0cm !important;
		border: initial !important; 
		border-radius: initial !important;  
		width: 6.6cm !important; 
		min-height: initial !important; 
		box-shadow: initial !important; 
		page-break-after: always !important; 
        margin:0px !important;
        /* background-color:blue !important; */
	}
	.bc-cotizacion{
		background: #4472c4;
	  	font-size: 20px;
	  	height: 30px;
	  	text-align: center;
	}
	.bc-cotizacion-equipos{
		background: #4472c4;
	  	font-size: 12px;
	  	text-align: center;
	}
	.bc-cotizacion-equipos td{
		padding: 2px 1px;
	}
	@page {
		size: portrait;
        padding:0px !important;
        margin:0px !important;
	}
}

@media screen {
  /* Contenido del fichero home.css */
}
/*.color-amcc{
	color: #2f3d79;
}*/
.img-center{
	display: block;
	margin: auto;
}

.fotos{
	page-break-inside: avoid;
}



</style>